export default {
  list: {
    pageTitle: {
      fullList: '全部商品',
    },
    containerTitle: {
      hotsale: '熱門產品',
    }
  },
  detail: {
    shippingCost: '運費 $ 28 及附加關稅',
    containerTitle: {
      description: '商品詳情',
      feature: '商品特色'
    },
    shareBodyText:'你的網址已成功複製到剪貼版，你可以前往社交工具分享您的朋友！',
    shareConfirmText:'我知道了'
  },

}



// WEBPACK FOOTER //
// ./src/Shop/langs/zh_hk/index.js